import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=65f07e6e&scoped=true&"
import script from "./ArrowButton.ts?vue&type=script&lang=ts&"
export * from "./ArrowButton.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f07e6e",
  null
  
)

export default component.exports